var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-bind" },
      [
        _c("van-nav-bar", { attrs: { title: "申请更换" } }),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                color: "#9c0003",
                "text-align": "left",
                "padding-left": ".2rem"
              }
            },
            [_vm._v("限时推广活动，此活动仅对老用户有效！！！")]
          ),
          _vm._v(" "),
          _c("fieldset", { staticClass: "md-field" }, [
            _c("div", { staticClass: "md-field-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "md-field-item md-input-item is-solid is-browser left normal"
                },
                [
                  _c("div", { staticClass: "md-field-item-content" }, [
                    _c("label", { staticClass: "md-field-item-title" }, [
                      _vm._v("原设备号")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-field-item-control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.iccid,
                            expression: "form.iccid"
                          }
                        ],
                        staticClass: "md-input-item-input",
                        attrs: {
                          max: "20",
                          name: "iccid",
                          placeholder: "以8986开头的数字",
                          maxlength: "",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.form.iccid },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "iccid", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "md-field" }, [
            _c("div", { staticClass: "md-field-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "md-field-item md-input-item is-solid is-browser left normal"
                },
                [
                  _c("div", { staticClass: "md-field-item-content" }, [
                    _c("label", { staticClass: "md-field-item-title" }, [
                      _vm._v("收件姓名")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-field-item-control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.name,
                            expression: "form.name"
                          }
                        ],
                        staticClass: "md-input-item-input",
                        attrs: {
                          max: "20",
                          name: "name",
                          placeholder: "请填写您的姓名",
                          maxlength: "",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.form.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "name", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "md-field" }, [
            _c("div", { staticClass: "md-field-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "md-field-item md-input-item is-solid is-browser left normal"
                },
                [
                  _c("div", { staticClass: "md-field-item-content" }, [
                    _c("label", { staticClass: "md-field-item-title" }, [
                      _vm._v("收件电话")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-field-item-control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.mobile,
                            expression: "form.mobile"
                          }
                        ],
                        staticClass: "md-input-item-input",
                        attrs: {
                          max: "20",
                          name: "mobile",
                          placeholder: "请填写您的电话",
                          maxlength: "",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.form.mobile },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "mobile", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "md-field" }, [
            _c("div", { staticClass: "md-field-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "md-field-item md-input-item is-solid is-browser left normal"
                },
                [
                  _c("div", { staticClass: "md-field-item-content" }, [
                    _c("label", { staticClass: "md-field-item-title" }, [
                      _vm._v("收件城市")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-field-item-control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.city,
                            expression: "form.city"
                          }
                        ],
                        staticClass: "md-input-item-input",
                        attrs: {
                          max: "20",
                          name: "mobile",
                          placeholder: "选择收货城市",
                          maxlength: "",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.form.city },
                        on: {
                          click: _vm.handleCityClick,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "city", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "md-field" }, [
            _c("div", { staticClass: "md-field-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "md-field-item md-input-item is-solid is-browser left normal"
                },
                [
                  _c("div", { staticClass: "md-field-item-content" }, [
                    _c("label", { staticClass: "md-field-item-title" }, [
                      _vm._v("详细地址")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-field-item-control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.address,
                            expression: "form.address"
                          }
                        ],
                        staticClass: "md-input-item-input",
                        attrs: {
                          max: "20",
                          name: "mobile",
                          placeholder: "详细收货地址",
                          maxlength: "",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.form.address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "address", $event.target.value)
                          }
                        }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "md-field" }, [
            _c("div", { staticClass: "md-field-content" }, [
              _c(
                "button",
                {
                  staticClass: "md-button primary active block",
                  attrs: { type: "button" },
                  on: { click: _vm.handleBindCard }
                },
                [_vm._m(0)]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            style: { height: "40%" },
            attrs: { position: "bottom" },
            model: {
              value: _vm.showAreaList,
              callback: function($$v) {
                _vm.showAreaList = $$v
              },
              expression: "showAreaList"
            }
          },
          [
            _c("van-area", {
              attrs: { "area-list": _vm.areaJs },
              on: {
                cancel: function($event) {
                  _vm.showAreaList = false
                },
                confirm: _vm.handleCityConfirm
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md-button-inner" }, [
      _c("div", { staticClass: "md-button-content" }, [
        _c("span", [_vm._v("提交申请")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0da48b34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da48b34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/change.vue
// module id = null
// module chunks = 